import { useEffect, useState } from 'react'
import { useAuthenticationDataContext } from '../../../Helpers/AuthenticationDataProvider';

import useFetchWrapper, { HttpResponse } from '../../../Helpers/useFetchWrapper';

import { Education, TabStatus, WorkExperience } from './ProfileTab.model';

const useProfileTab = () => {
  const [ education, setEducation ] = useState<Education[]>();
  const [ tabStatus, setTabStatus ] = useState<TabStatus>(TabStatus.Loading);
  const [ workExperience, setWorkExperience ] = useState<WorkExperience[]>();
	const { userId } = useAuthenticationDataContext();

  const { get } = useFetchWrapper();

  useEffect(() => {
    getEducation();
    getWorkExperience();
  }, [userId]);

  const getEducation = async () => {
    const response: HttpResponse<Education[]> = await get(`/user/profile/education/${userId}`);

    const education: Education[] = response.parsedBody?.map((ed: Education) => ({
      description: ed.description,
      educationId: ed.educationId,
      endDate: ed.endDate,
      institution: ed.institution,
      location: ed.location,
      obtainedDegree: ed.obtainedDegree,
      startDate: ed.startDate,
    })) || [];

    setEducation(education.sort((a, b) => a.startDate < b.startDate ? 1 : -1));
  }


  const getWorkExperience = async () => {
    const response: HttpResponse<WorkExperience[]> = await get(`/user/profile/work-experience/${userId}`);

    const workExperience: WorkExperience[] = response.parsedBody?.map((exp: WorkExperience) => ({
      currentPosition: exp.currentPosition,
      description: exp.description,
      endDate: exp.endDate,
      institution: exp.institution,
      location: exp.location,
      startDate: exp.startDate,
      workExperienceId: exp.workExperienceId
    })) || [];

    setWorkExperience(workExperience.sort((a, b) => a.startDate < b.startDate ? 1 : -1));

    setTabStatus(TabStatus.Loaded);
  }

  return {
    state: {
			education,
      tabStatus,
      workExperience,
    },
  }

}
export default useProfileTab;